/* eslint complexity: ["error", 40] */

import React, {Fragment, useState, useEffect, useCallback, useRef} from 'react';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router-dom';
import {Alert, Button, Container, Fade, Form, Tab, Tabs, ToggleButton, ToggleButtonGroup, Modal, Spinner} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import Dialog from 'react-bootstrap-dialog';
import {FaChartBar, FaDatabase, FaDownload, FaExternalLinkAlt, FaFilm, FaFilter, FaFolder, FaFolderPlus, FaHandshake, FaMagic, FaMapMarkerAlt, FaPlus, FaRedoAlt, FaSave, FaShareAlt, FaShieldAlt, FaTag, FaTimes, FaTrashAlt} from 'react-icons/fa';
import {AiOutlineClockCircle, AiOutlineCalendar} from 'react-icons/ai';
import {Formik} from 'formik';
import PlayerHighLight from './player-highlight';
import PlayerVideoAnalysisReport from './player-video-analysis-report';
import PlayerVideoAnalysisSharing from './player-video-analysis-sharing';
import PlayerVideoSharing from './player-video-sharing';
import {sharingType} from '../constants';
import editIcon from '../images/edit_icon.svg';
import binIcon from '../images/bin_icon.svg';
import privateIcon from '../images/user_icon_private_red.svg';
import publicIcon from '../images/user_icon_public_red.svg';
import replayerIcon from '../images/user_icon_replayer_red.svg';
import Configuration from '../config';
import playArrowWhite from '../images/play_arrow_white_48dp.png';
import replayerlogoBianco from '../images/replayer_logo_bianco_40x32px.png';
import noLogo from '../images/club_icon_grey.svg';
import {useTranslation} from 'react-i18next';
import PlayerTags from './player-tags';
import PlayerVideoTagging from './player-video-tagging';
import * as api from '../api';
import {isPickleballVideo} from '../util/video-sports';
import {openVideoPlayer, preconnectVideoPlayer} from '../utils/video-player-preload';

const PlayerVideo = ({
  token,
  profile,
  permanentVideos,
  permanentPartnerVideos,
  storagePrices,
  selectVideoForHighlight,
  selectVideoForAnalysis,
  selectedPermanentVideo,
  deletePlayerPermanentVideo,
  deletePlayerPermanentPartnerVideo,
  deletePlaylist,
  modifyPlayerPermanentVideo,
  modifyPlaylist,
  showVideosSharing,
  partners,
  addPermanentVideoPlaying,
  permanentVideosPlaying,
  showPlayerTags,
  userTags,
  myVideoActiveTab,
  setActiveTab,
  showVideoTagging,
  selectedVideoForTagging,
  searchTaggedVideo,
  taggedUserVideos,
  addTaggedVideoPlaying,
  taggedVideosPlaying,
  changeStorageType,
  isStorageModalVisible,
  hideStorageModal,
  showStorageModal,
  playlists,
  highlightFolders,
  videoFolders,
  getPlayerPermanentVideos,
  getPlayerPermanentPartnerVideos,
  getPlayerPlaylists,
  getUserTags,
  getTaggedUserVideos,
  playerGetStoragePrices,
  getPlayerHighlightFolders,
  createPlayerHighlightFolder,
  deletePlayerHighlightFolder,
  movePlayerHighlightToFolder,
  getPlayerVideoFolders,
  createPlayerVideoFolder,
  deletePlayerVideoFolder,
  movePlayerVideoToFolder,
  createHighlightPlaylist,
  exportPlaylist,
  goto,
  sendUsageData,
  location,
}) => {
  const [value, setValue] = useState([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [activeHighlightFolderId, setActiveHighlightFolderId] = useState('all');
  const [activeVideoFolderId, setActiveVideoFolderId] = useState('all');
  const [newHighlightFolderName, setNewHighlightFolderName] = useState('');
  const [newVideoFolderName, setNewVideoFolderName] = useState('');
  const [pendingHighlightFolderName, setPendingHighlightFolderName] = useState(null);
  const [pendingVideoFolderName, setPendingVideoFolderName] = useState(null);
  const [selectedHighlightIds, setSelectedHighlightIds] = useState([]);
  const [selectedHighlightCameraIds, setSelectedHighlightCameraIds] = useState({});
  const [isHighlightPlaylistModalVisible, setHighlightPlaylistModalVisible] = useState(false);
  const [isHighlightGuideModalVisible, setHighlightGuideModalVisible] = useState(false);
  const [isVideoGuideModalVisible, setVideoGuideModalVisible] = useState(false);
  const [videoActionModal, setVideoActionModal] = useState(null);
  const [analysisRequests, setAnalysisRequests] = useState([]);
  const [loadingAnalysisRequests, setLoadingAnalysisRequests] = useState(false);
  const [analysisRequestsError, setAnalysisRequestsError] = useState(null);
  const [deletingAnalysisRequestId, setDeletingAnalysisRequestId] = useState(null);
  const [selectedAnalysisReportRequest, setSelectedAnalysisReportRequest] = useState(null);
  const [selectedAnalysisSharingRequest, setSelectedAnalysisSharingRequest] = useState(null);
  const appliedFolderDeepLink = useRef(null);
  const loadedMyVideoSections = useRef({});
  const loadedMyVideoResources = useRef({});
  const [loadingMyVideoSection, setLoadingMyVideoSection] = useState(null);
  const {t, i18n} = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(location.search || '');
    const section = params.get('section');
    if (['highlight', 'video', 'partner_videos', 'analysis', 'tags', 'playlist'].includes(section) && section !== myVideoActiveTab) {
      setActiveTab(section);
    }
  }, [location.search, myVideoActiveTab, setActiveTab]);

  useEffect(() => {
    const params = new URLSearchParams(location.search || '');
    const section = params.get('section');
    const folderQuery = (params.get('folder') || '').trim().toLowerCase();
    const deepLinkKey = `${section || ''}:${folderQuery}`;
    if (!folderQuery || appliedFolderDeepLink.current === deepLinkKey) return;
    const folders = section === 'highlight' ? highlightFolders : (section === 'video' ? videoFolders : []);
    if (!folders.length) return;
    const exactFolder = folders.find(folder => folder.name.toLowerCase() === folderQuery);
    const matchingFolder = exactFolder || folders.find(folder => folder.name.toLowerCase().includes(folderQuery));
    if (matchingFolder) {
      if (section === 'highlight') setActiveHighlightFolderId(String(matchingFolder.id));
      if (section === 'video') setActiveVideoFolderId(String(matchingFolder.id));
    }
    appliedFolderDeepLink.current = deepLinkKey;
  }, [highlightFolders, location.search, videoFolders]);

  useEffect(() => {
    window.scrollTo(0, scrollPosition);
  });

  const loadAnalysisRequests = useCallback(() => {
    if (!token) return;

    setLoadingAnalysisRequests(true);
    setAnalysisRequestsError(null);
    return api.getVideoAnalysisRequests(token).then(result => {
      setLoadingAnalysisRequests(false);
      if (result.status >= 200 && result.status < 300) {
        const requests = Array.isArray(result.json)
          ? result.json
          : result.json.requests || result.json.items || [];
        setAnalysisRequests(requests);
        return;
      }
      setAnalysisRequestsError(t('VIDEO_ANALYSIS_LOAD_ERROR'));
    });
  }, [token, t]);

  useEffect(() => {
    if (!token || loadedMyVideoSections.current[myVideoActiveTab]) {
      return undefined;
    }

    loadedMyVideoSections.current[myVideoActiveTab] = true;
    setLoadingMyVideoSection(myVideoActiveTab);
    const sectionResources = {
      highlight: [
        ['permanentVideos', getPlayerPermanentVideos],
        ['highlightFolders', getPlayerHighlightFolders],
        ['playlists', getPlayerPlaylists],
        ['storagePrices', playerGetStoragePrices]
      ],
      video: [
        ['permanentVideos', getPlayerPermanentVideos],
        ['videoFolders', getPlayerVideoFolders],
        ['storagePrices', playerGetStoragePrices]
      ],
      partner_videos: [
        ['permanentPartnerVideos', getPlayerPermanentPartnerVideos],
        ['storagePrices', playerGetStoragePrices]
      ],
      analysis: [['analysisRequests', loadAnalysisRequests]],
      tags: [
        ['userTags', getUserTags],
        ['taggedUserVideos', getTaggedUserVideos]
      ],
      playlist: [['playlists', getPlayerPlaylists]]
    };
    const resources = (sectionResources[myVideoActiveTab] || []).filter(([resourceKey]) => !loadedMyVideoResources.current[resourceKey]);
    resources.forEach(([resourceKey]) => {
      loadedMyVideoResources.current[resourceKey] = true;
    });
    let active = true;
    Promise.all(resources.map(([, load]) => Promise.resolve(load()))).then(() => {
      if (active) setLoadingMyVideoSection(null);
    }, () => {
      loadedMyVideoSections.current[myVideoActiveTab] = false;
      resources.forEach(([resourceKey]) => {
        loadedMyVideoResources.current[resourceKey] = false;
      });
      if (active) setLoadingMyVideoSection(null);
    });

    return () => {
      active = false;
    };
  }, [
    getPlayerHighlightFolders,
    getPlayerPermanentPartnerVideos,
    getPlayerPermanentVideos,
    getPlayerPlaylists,
    getPlayerVideoFolders,
    getTaggedUserVideos,
    getUserTags,
    loadAnalysisRequests,
    myVideoActiveTab,
    playerGetStoragePrices,
    token
  ]);

  useEffect(() => {
    if (!pendingHighlightFolderName) {
      return;
    }

    const createdFolder = highlightFolders.find(folder => folder.name === pendingHighlightFolderName);
    if (createdFolder) {
      setActiveHighlightFolderId(String(createdFolder.id));
      setPendingHighlightFolderName(null);
    }
  }, [highlightFolders, pendingHighlightFolderName]);

  useEffect(() => {
    if (!pendingVideoFolderName) {
      return;
    }

    const createdFolder = videoFolders.find(folder => folder.name === pendingVideoFolderName);
    if (createdFolder) {
      setActiveVideoFolderId(String(createdFolder.id));
      setPendingVideoFolderName(null);
    }
  }, [videoFolders, pendingVideoFolderName]);

  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  const getScrollPage = () => {
    let docScrollTop = 0;
    if (document.documentElement && document.documentElement !== null) {
      docScrollTop = document.documentElement.scrollTop;
    }
    return window.pageYOffset || docScrollTop;
  };

  let dialog = null;
  const confirmDeleteVideo = videoId => () => {
    setVideoActionModal({type: 'delete', videoId});
  };

  const confirmDeletePartnerVideo = videoId => () => {
    dialog.show({
      title: t('CONFIRM_DELETE_VIDEO'),
      body: t('CONFIRM_DELETE_VIDEO_DESC'),
      actions: [
        Dialog.Action(
          t('YES'),
          () => deletePlayerPermanentPartnerVideo(videoId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const confirmDownloadVideo = video => () => {
    setVideoActionModal({type: 'download', video});
  };


  const confirmDeletePlaylist = playlistId => () => {
    dialog.show({
      title: t('CONFIRM_DELETE_VIDEO'),
      body: t('CONFIRM_DELETE_VIDEO_DESC'),
      actions: [
        Dialog.Action(
          t('YES'),
          () => deletePlaylist(playlistId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const safeDownloadFilename = name => {
    const baseName = String(name || 'playlist')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
    return `${baseName || 'playlist'}.mp4`;
  };

  const playlistDownloadUrl = playlist => {
    const downloadUrl = playlist.exportDownloadUrl;
    if (!downloadUrl || /\.mp4(?:\?|$)/i.test(downloadUrl)) {
      return downloadUrl;
    }

    const separator = downloadUrl.endsWith('/') ? '' : '/';
    return `${downloadUrl}${separator}${safeDownloadFilename(playlist.name)}`;
  };

  const downloadPlaylistExport = playlist => event => {
    event.preventDefault();
    if (!playlist.exportDownloadUrl) {
      return;
    }

    const link = document.createElement('a');
    link.href = playlistDownloadUrl(playlist);
    link.download = safeDownloadFilename(playlist.name);
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const playlistExportAction = playlist => {
    if (playlist.exportStatus === 'finished' && playlist.exportDownloadUrl) {
      return (
        <Fragment>
          <Button
            className="btn myvideo-action myvideo-action--download mb-3 ml-1 mr-1"
            onClick={downloadPlaylistExport(playlist)}
          >
            <FaDownload aria-hidden="true"/>{t('MYVIDEO_DOWNLOAD_MP4')}
          </Button>
          <Button className="btn myvideo-action myvideo-action--utility mb-3 ml-1 mr-1" onClick={() => exportPlaylist(playlist.id, true)}>
            <FaRedoAlt aria-hidden="true"/>{t('MYVIDEO_REGENERATE_MP4')}
          </Button>
        </Fragment>
      );
    }
    if (playlist.exportStatus === 'pending' || playlist.exportStatus === 'running') {
      return (
        <Button className="btn myvideo-action myvideo-action--utility mb-3 ml-1 mr-1" disabled>
          {t('MYVIDEO_GENERATING')}
        </Button>
      );
    }
    return (
      <Button className="btn myvideo-action myvideo-action--download mb-3 ml-1 mr-1" onClick={() => exportPlaylist(playlist.id)}>
        {playlist.exportStatus === 'error' ? <FaRedoAlt aria-hidden="true"/> : <FaFilm aria-hidden="true"/>}
        {playlist.exportStatus === 'error' ? t('MYVIDEO_REGENERATE_MP4') : t('MYVIDEO_GENERATE_MP4')}
      </Button>
    );
  };

  const metadataVideo = video => () => {
    dialog.show({
      title: t('VIDEO_METADATA'),
      body: <Fragment>
              <Form.Group>
                {t('VIDEO_METADATA_DESC')}
              </Form.Group>
              <Form.Group>
                <Form.Label><FaMapMarkerAlt size="1.5em" style={{marginRight: 10}}/>{video.city}</Form.Label>
              </Form.Group>
              <Form.Group>
                <Form.Label><FaShieldAlt size="1.5em" style={{marginRight: 10}}/>{video.partnerName}, {video.fieldName}</Form.Label>
              </Form.Group>
              <Form.Group>
                <Form.Label><AiOutlineCalendar size="1.5em" style={{marginRight: 10}}/>{new Date(video.startDatetime).toLocaleDateString(i18n.language, {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})}</Form.Label>
              </Form.Group>
              <Form.Group>
                <Form.Label><AiOutlineClockCircle size="1.5em" style={{marginRight: 10}}/>{t('FROM_TO_TIME', {fromTime: new Date(video.startDatetime).toLocaleTimeString(i18n.language).slice(0, 5), toTime: new Date(video.endDatetime).toLocaleTimeString(i18n.language).slice(0, 5)})}</Form.Label>
              </Form.Group>
            </Fragment>,
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const getPartnerLogo = partnerId => {
    const partner = partners.find(p => p.uid === partnerId);
    if (partner && partner.storeImage && partner.storeImage.length > 0) {
      return `${Configuration.apiEndPoint}/images/${partnerId}?load=${partner.storeImage[0]}`;
    }

    return noLogo;
  };

  const styleBackgroundImage = (partnerId, fieldId, fieldImage) => {
    if (partnerId && fieldImage) {
      return {backgroundImage: `url(${Configuration.apiEndPoint}/partners/fields/${fieldId}/images?load=${fieldImage})`, backgroundSize: 'cover'};
    }

    return null;
  };

  const styleBackgroundImageVideoPartner = (partnerId, coverImage, defaultImage, videoId) => {
    if (coverImage && coverImage[0]) {
      return {backgroundImage: `url(${Configuration.apiEndPoint}/user_video_partners/${videoId}/images?load=${coverImage[0]}`, backgroundSize: 'cover'};
    }
    if (defaultImage && defaultImage[0]) {
      return {backgroundImage: `url(${Configuration.apiEndPoint}/images/${partnerId}?load=${defaultImage[0]}`, backgroundSize: 'cover'};
    }

    return null;
  };

  const handleTagSelection = val => {
    setValue(val);
    searchTaggedVideo(val);
  };

  const storageLimit = {
    xs: 20,
    s: 30,
    m: 50,
    l: 100,
    xl: 200,
    xxl: 500,
    xxxl: 1000,
  }

  const selectableStorageType = profile.storageType === "xs" ? "s" : profile.storageType;

  const usageTypes = {
    replayer_video: 1,
    partner_video: 2,
    highlight: 3,
    playlist: 4,
  }

  const analysisStatusLabel = status => ({
    created: t('VIDEO_ANALYSIS_STATUS_CREATED'),
    payment_confirmed: t('VIDEO_ANALYSIS_STATUS_CONFIRMED'),
    waiting_video_slices: t('VIDEO_ANALYSIS_STATUS_WAITING_VIDEO'),
    clip_generating: t('VIDEO_ANALYSIS_STATUS_CLIP'),
    queued_to_provider: t('VIDEO_ANALYSIS_STATUS_QUEUED'),
    processing: t('VIDEO_ANALYSIS_STATUS_PROCESSING'),
    available: t('VIDEO_ANALYSIS_STATUS_AVAILABLE'),
    failed: t('VIDEO_ANALYSIS_STATUS_FAILED'),
    refunded: t('VIDEO_ANALYSIS_STATUS_REFUNDED')
  }[status] || status || t('VIDEO_ANALYSIS_STATUS_DEFAULT'));

  const analysisStatusDescription = status => ({
    created: t('VIDEO_ANALYSIS_DESCRIPTION_CREATED'),
    payment_confirmed: t('VIDEO_ANALYSIS_DESCRIPTION_CONFIRMED'),
    waiting_video_slices: t('VIDEO_ANALYSIS_DESCRIPTION_WAITING_VIDEO'),
    clip_generating: t('VIDEO_ANALYSIS_DESCRIPTION_CLIP'),
    queued_to_provider: t('VIDEO_ANALYSIS_DESCRIPTION_QUEUED'),
    processing: t('VIDEO_ANALYSIS_DESCRIPTION_PROCESSING'),
    available: t('VIDEO_ANALYSIS_DESCRIPTION_AVAILABLE'),
    failed: t('VIDEO_ANALYSIS_DESCRIPTION_FAILED'),
    refunded: t('VIDEO_ANALYSIS_DESCRIPTION_REFUNDED')
  }[status] || t('VIDEO_ANALYSIS_DESCRIPTION_DEFAULT'));

  const analysisResultUrl = request => (
    request.providerResultUrl
    || request.provider_result_url
    || request.providerWebpageUrl
    || request.provider_webpage_url
    || request.webpageUrl
    || request.webpage
    || null
  );
  const replayerAnalysisUiEnabled = Configuration.videoAnalysisReplayerUiEnabled !== false;

  const formatAnalysisRange = request => {
    const start = Number(request.startSecond || request.start_second || 0);
    const end = Number(request.endSecond || request.end_second || 0);
    const format = seconds => new Date(Math.max(0, seconds) * 1000).toISOString().slice(11, 19);
    return `${format(start)} - ${format(end)}`;
  };

  const formatAnalysisPrice = request => {
    const cents = Number(request.priceCents || request.price_cents || request.amountCents || request.amount_cents || 0);
    return `${(cents / 100).toFixed(2)} EUR`;
  };

  const deleteAnalysisRequest = request => async event => {
    event.preventDefault();
    setDeletingAnalysisRequestId(request.id);
    setAnalysisRequestsError(null);
    const result = await api.deleteVideoAnalysisRequest(request.id, token);
    setDeletingAnalysisRequestId(null);
    if (result.status >= 200 && result.status < 300) {
      loadAnalysisRequests();
      return;
    }
    const error = result.json && result.json.error === 'analysis_already_sent_to_provider'
      ? t('VIDEO_ANALYSIS_DELETE_PROCESSING_ERROR')
      : t('VIDEO_ANALYSIS_DELETE_ERROR');
    setAnalysisRequestsError(error);
  };

  const openAnalysisSharing = request => event => {
    event.preventDefault();
    setSelectedAnalysisSharingRequest(request);
  };

  const updateSharedAnalysisRequest = updatedRequest => {
    setAnalysisRequests(items => items.map(item => (
      item.id === updatedRequest.id ? {...item, ...updatedRequest} : item
    )));
    setSelectedAnalysisSharingRequest(updatedRequest);
  };

  const openPlayerUrl = url => {
    openVideoPlayer(url);
  };

  const getHighlightPlayerUrl = v => {
    const params = new URLSearchParams();
    if (v.slotId) {
      params.set('slotId', v.slotId);
    }
    params.set('videoId', v.videoId);
    params.set('token', v.token);
    return `${Configuration.krpanoPlayerUrl}?${params.toString()}`;
  };

  const playHighlightVideo = v => event => {
    if (event) {
      event.preventDefault();
    }
    openPlayerUrl(getHighlightPlayerUrl(v));
    sendUsageData(usageTypes['highlight'], v.partnerId, v.slotId);
  };

  const replayerVideos = permanentVideos.filter(v => !v.highlight);
  const videosWithoutFolderCount = replayerVideos.filter(v => !v.videoFolderId).length;
  const getVideoFolderCount = folderId => (
    replayerVideos.filter(v => String(v.videoFolderId) === String(folderId)).length
  );
  const visibleReplayerVideos = replayerVideos.filter(v => {
    if (activeVideoFolderId === 'all') {
      return true;
    }
    if (activeVideoFolderId === 'none') {
      return !v.videoFolderId;
    }
    return String(v.videoFolderId) === activeVideoFolderId;
  });
  const selectedVideoFolder = videoFolders.find(f => String(f.id) === activeVideoFolderId);

  const highlights = permanentVideos.filter(v => v.highlight);
  const highlightsWithoutFolderCount = highlights.filter(v => !v.highlightFolderId).length;
  const getHighlightFolderCount = folderId => (
    highlights.filter(v => String(v.highlightFolderId) === String(folderId)).length
  );
  const visibleHighlights = highlights.filter(v => {
    if (activeHighlightFolderId === 'all') {
      return true;
    }
    if (activeHighlightFolderId === 'none') {
      return !v.highlightFolderId;
    }
    return String(v.highlightFolderId) === activeHighlightFolderId;
  });
  const selectedHighlightFolder = highlightFolders.find(f => String(f.id) === activeHighlightFolderId);
  const selectedHighlights = visibleHighlights.filter(v => selectedHighlightIds.includes(v.videoId));
  const getAvailableFlatCameras = v => (
    Array.isArray(v.cameras)
      ? v.cameras.filter(camera => camera.camera_type === 'flat' && camera.cameraExistInSlotCamera)
      : []
  );
  const getSelectedHighlightCameraId = v => {
    const selectedCameraId = selectedHighlightCameraIds[v.videoId];
    if (selectedCameraId) {
      return Number(selectedCameraId);
    }
    const flatCameras = getAvailableFlatCameras(v);
    return flatCameras.length > 0 ? Number(flatCameras[0].value) : null;
  };
  const isFlatHighlight = v => (
    getAvailableFlatCameras(v).some(camera => Number(camera.value) === Number(getSelectedHighlightCameraId(v)))
  );
  const canCreateHighlightPlaylist = selectedHighlights.length >= 2 &&
    selectedHighlights.every(isFlatHighlight);
  const changeHighlightPlaylistCamera = videoId => event => {
    event.stopPropagation();
    setSelectedHighlightCameraIds(currentCameraIds => ({
      ...currentCameraIds,
      [videoId]: Number(event.target.value)
    }));
  };
  const toggleHighlightSelection = v => event => {
    event.stopPropagation();
    const flatCameras = getAvailableFlatCameras(v);
    if (flatCameras.length === 0) {
      return;
    }
    setSelectedHighlightCameraIds(currentCameraIds => ({
      ...currentCameraIds,
      [v.videoId]: currentCameraIds[v.videoId] || Number(flatCameras[0].value)
    }));
    setSelectedHighlightIds(currentIds => {
      if (currentIds.includes(v.videoId)) {
        const nextIds = currentIds.filter(id => id !== v.videoId);
        setSelectedHighlightCameraIds(currentCameraIds => {
          const nextCameraIds = {...currentCameraIds};
          delete nextCameraIds[v.videoId];
          return nextCameraIds;
        });
        return nextIds;
      }
      return [...currentIds, v.videoId];
    });
  };
  const clearHighlightPlaylistSelection = () => {
    setSelectedHighlightIds([]);
    setSelectedHighlightCameraIds({});
  };
  const openHighlightPlaylistModal = event => {
    event.preventDefault();
    if (canCreateHighlightPlaylist) {
      setHighlightPlaylistModalVisible(true);
    }
  };
  const addHighlightFolder = event => {
    event.preventDefault();
    const folderName = newHighlightFolderName.trim();
    if (!folderName) {
      return;
    }
    createPlayerHighlightFolder(folderName);
    setPendingHighlightFolderName(folderName);
    setNewHighlightFolderName('');
  };
  const addVideoFolder = event => {
    event.preventDefault();
    const folderName = newVideoFolderName.trim();
    if (!folderName) {
      return;
    }
    createPlayerVideoFolder(folderName);
    setPendingVideoFolderName(folderName);
    setNewVideoFolderName('');
  };
  const deleteSelectedHighlightFolder = event => {
    event.preventDefault();
    if (!selectedHighlightFolder) {
      return;
    }
    dialog.show({
      title: t('MYVIDEO_DELETE_FOLDER'),
      body: (
        <Fragment>
          <p>{t('MYVIDEO_DELETE_FOLDER_CONFIRM', {name: selectedHighlightFolder.name})}</p>
          <p>{t('MYVIDEO_DELETE_HIGHLIGHT_FOLDER_HELP')}</p>
        </Fragment>
      ),
      actions: [
        Dialog.Action(
          t('MYVIDEO_DELETE_FOLDER'),
          () => {
            deletePlayerHighlightFolder(selectedHighlightFolder.id);
            setActiveHighlightFolderId('all');
          },
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };
  const deleteSelectedVideoFolder = event => {
    event.preventDefault();
    if (!selectedVideoFolder) {
      return;
    }
    dialog.show({
      title: t('MYVIDEO_DELETE_FOLDER'),
      body: (
        <Fragment>
          <p>{t('MYVIDEO_DELETE_FOLDER_CONFIRM', {name: selectedVideoFolder.name})}</p>
          <p>{t('MYVIDEO_DELETE_VIDEO_FOLDER_HELP')}</p>
        </Fragment>
      ),
      actions: [
        Dialog.Action(
          t('MYVIDEO_DELETE_FOLDER'),
          () => {
            deletePlayerVideoFolder(selectedVideoFolder.id);
            setActiveVideoFolderId('all');
          },
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };
  const shareSelectedHighlightFolder = event => {
    event.preventDefault();
    if (!selectedHighlightFolder) {
      return;
    }
    showVideosSharing({
      name: selectedHighlightFolder.name,
      sharing: selectedHighlightFolder.sharing,
      sharingId: selectedHighlightFolder.sharingId,
      folderId: selectedHighlightFolder.id,
    })();
  };

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear'}}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
            <div className="dashboard_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp" style={{minHeight: 800}}>
            <div className="section">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <h4 className="section_title_neg_rp">{t('MY_VIDEO')}</h4>
                    <br/>
                    <h4 className="section_title_neg_rp">{(Math.floor(profile.videoQuota)/(1000000000)).toFixed(2)}GB/{storageLimit[profile.storageType]}GB</h4>
                  </div>
                  <div className="col-md-12 ml-auto mr-auto" style={{textAlign: 'right', marginTop: -42}}>
                    <button type="button" className="btn myvideo-action myvideo-action--utility mb-3 ml-1 mr-1" onClick={showStorageModal}><FaDatabase aria-hidden="true"/>{t('MANAGE_SPACE')}</button>
                  </div>
                </div>
                {loadingMyVideoSection === myVideoActiveTab ?
                  <div className="alert alert-light d-flex align-items-center" role="status" aria-live="polite">
                    <Spinner animation="border" size="sm" className="mr-2"/>
                    <span>{t('LOADING_DATA_IN_PROGRESS')}</span>
                  </div> : null}
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <Tabs activeKey={myVideoActiveTab} className="myvideo-tabs myvideo-section-tabs" onSelect={t => setActiveTab(t)}>
                      <Tab eventKey="highlight" title={<span className="section-tab-label"><FaMagic aria-hidden="true"/>{t('HIGHLIGHT')}</span>} tabClassName="myvideo-tab myvideo-tab--highlight">
                        <div className="myvideo-highlight-organizer" style={{marginTop: 35}}>
                          <div className="myvideo-highlight-organizer-header">
                            <div>
                              <h5>{t('ORGANIZE_HIGHLIGHTS')}</h5>
                              <p>{t('ORGANIZE_HIGHLIGHTS_DESCRIPTION')}</p>
                            </div>
                            <div className="myvideo-highlight-header-actions">
                              <Button className="myvideo-highlight-guide-btn" onClick={() => setHighlightGuideModalVisible(true)}>{t('HIGHLIGHT_GUIDE')}</Button>
                              <div className="myvideo-highlight-total">{highlights.length} highlight</div>
                            </div>
                          </div>
                          <div className="row align-items-stretch myvideo-highlight-controls">
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                              <Form.Label className="myvideo-folder-control-label"><FaFilter aria-hidden="true"/><span>{t('VIEW')}</span></Form.Label>
                              <Form.Control className="myvideo-folder-select" as="select" value={activeHighlightFolderId} onChange={event => setActiveHighlightFolderId(event.target.value)}>
                                <option value="all">{t('MYVIDEO_ALL_HIGHLIGHTS', {count: highlights.length})}</option>
                                <option value="none">{t('MYVIDEO_HIGHLIGHTS_WITHOUT_FOLDER', {count: highlightsWithoutFolderCount})}</option>
                                {highlightFolders.map(folder => (
                                  <option key={folder.id} value={folder.id}>{t('MYVIDEO_FOLDER_OPTION', {name: folder.name, count: getHighlightFolderCount(folder.id)})}</option>
                                ))}
                              </Form.Control>
                              <small className="myvideo-folder-control-hint">{t('MYVIDEO_HIGHLIGHTS_IN_SELECTION', {count: visibleHighlights.length})}</small>
                              </div>
                            </div>
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                              <Form onSubmit={addHighlightFolder}>
                                <Form.Label className="myvideo-folder-control-label"><FaFolderPlus aria-hidden="true"/><span>{t('NEW_FOLDER')}</span></Form.Label>
                                <div className="input-group myvideo-folder-create-control">
                                  <Form.Control maxLength={120} value={newHighlightFolderName} placeholder={t('FOLDER_NAME')} onChange={event => setNewHighlightFolderName(event.target.value)}/>
                                  <div className="input-group-append">
                                    <Button type="submit" className="btn myvideo-action myvideo-folder-create-btn" disabled={!newHighlightFolderName.trim()}><FaPlus aria-hidden="true"/>{t('CREATE')}</Button>
                                  </div>
                                </div>
                                <small className="myvideo-folder-control-hint">{t('HIGHLIGHT_FOLDER_HINT')}</small>
                              </Form>
                              </div>
                            </div>
                            <div className="col-md-2 mb-3 text-md-right">
                              {selectedHighlightFolder ? (
                                <div className="myvideo-highlight-folder-actions">
                                  <Button className="btn myvideo-action myvideo-action--share mb-2" onClick={shareSelectedHighlightFolder}><FaShareAlt aria-hidden="true"/>{t('MYVIDEO_SHARE_FOLDER')}</Button>
                                  <Button className="btn myvideo-action myvideo-action--danger" onClick={deleteSelectedHighlightFolder}><FaTrashAlt aria-hidden="true"/>{t('MYVIDEO_DELETE_FOLDER')}</Button>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        {selectedHighlightIds.length > 0 ? (
                          <div className="myvideo-highlight-playlist-bar">
                            <div>
                              <strong>{t('MYVIDEO_HIGHLIGHTS_SELECTED', {count: selectedHighlightIds.length})}</strong>
                              <span>
                                {canCreateHighlightPlaylist
                                  ? t('MYVIDEO_PLAYLIST_READY')
                                  : t('MYVIDEO_PLAYLIST_MINIMUM_HELP')}
                              </span>
                            </div>
                            <div className="myvideo-highlight-playlist-actions">
                              <Button className="btn myvideo-action myvideo-action--utility" onClick={clearHighlightPlaylistSelection}><FaTimes aria-hidden="true"/>{t('MYVIDEO_CANCEL_SELECTION')}</Button>
                              <Button className="btn myvideo-action myvideo-action--playlist" disabled={!canCreateHighlightPlaylist} onClick={openHighlightPlaylistModal}><FaFolderPlus aria-hidden="true"/>{t('MYVIDEO_CREATE_PLAYLIST')}</Button>
                            </div>
                          </div>
                        ) : null}
                        <div className="row" style={{marginTop: 50}}>
                          {visibleHighlights.length === 0 ? (
                            <div className="col-12">
                              <div className="myvideo-highlight-empty">
                                {selectedHighlightFolder
                                  ? t('MYVIDEO_EMPTY_HIGHLIGHT_FOLDER')
                                  : t('MYVIDEO_NO_HIGHLIGHTS_SELECTION')}
                              </div>
                            </div>
                          ) : null}
                          {
                            visibleHighlights.map(v =>
                              (
                                <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                  <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--highlight">
                                    <div className="video_card_image" style={{...(styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage) || {}), cursor: 'pointer'}} onClick={playHighlightVideo(v)}>
                                      <div className="videoWrapper">
                                        <Fragment>
                                          <div className="preload h-100 justify-content-center align-items-center">
                                            <img className="play_arrow" src={playArrowWhite} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-start align-items-start">
                                            <img className="logo-replayer" src={replayerlogoBianco} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-end align-items-start">
                                            <img className="logo-partner" src={getPartnerLogo(v.partnerId)} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-center align-items-end">
                                            <div className="video-description justify-content-center align-items-center">{v.name.substring(0,60)}</div>
                                          </div>
                                        </Fragment>
                                      </div>
                                    </div>
                                    <Formik
                                      enableReinitialize
                                      initialValues={{videoId: v.videoId, name: v.name, description: v.description, renaming: false}}
                                      onSubmit={values => modifyPlayerPermanentVideo(values.videoId, {name: values.name, description: values.description})}
                                    >
                                      {({
                                        handleSubmit,
                                        handleChange,
                                        values,
                                        setFieldValue
                                      }) => {
                                        const rename = formData => {
                                          handleSubmit(formData);
                                          setFieldValue('renaming', false);
                                        };

                                        const setRenameAndScroll = () => {
                                          setScrollPosition(getScrollPage());
                                          setFieldValue('renaming', true);
                                        };

                                        if (values.renaming) {
                                          return (
                                            <div className="card-body d-flex flex-column">
                                              <Form onSubmit={rename}>
                                                <Form.Group>
                                                  <Form.Label>{t('TITLE')}*</Form.Label>
                                                  <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={255} value={values.name || ''} onChange={handleChange}/>
                                                </Form.Group>
                                                <Form.Group>
                                                  <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                  <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange}/>
                                                </Form.Group>
                                                <div className="d-flex flex-row-reverse">
                                                  <button type="button" className="btn myvideo-action myvideo-action--utility ml-1" onClick={() => setFieldValue('renaming', false)}><FaTimes aria-hidden="true"/>{t('CANCEL')}</button>
                                                  <Button className="btn myvideo-action myvideo-action--primary ml-1 mr-1" type="submit"><FaSave aria-hidden="true"/>{t('SAVE')}</Button>
                                                </div>
                                              </Form>
                                            </div>
                                          );
                                        }

                                        return (
                                          <Fragment>
                                            <div className="card-body d-flex flex-column" style={{cursor: 'pointer'}} onClick={playHighlightVideo(v)}>
                                              <div className="skywork-video-card-title-box"><h5 className="card-title">{v.name}</h5></div>
                                              <div className="video_card_star_btn_active" onClick={event => {event.stopPropagation(); metadataVideo(v)();}}/>
                                              <div className="skywork-video-card-description-box">{v.description || t('VIDEO_ANALYSIS_NO_DESCRIPTION')}</div>
                                            </div>
                                            <div className="px-3 pb-3 myvideo-card-folder-control">
                                              <Form.Label><FaFolder aria-hidden="true"/><span>{t('MYVIDEO_ARCHIVE_IN')}</span></Form.Label>
                                              <Form.Control className="myvideo-card-folder-select" as="select" value={v.highlightFolderId || ''} onChange={event => movePlayerHighlightToFolder(v.videoId, event.target.value ? Number(event.target.value) : null)}>
                                                <option value="">{t('MYVIDEO_WITHOUT_FOLDER')}</option>
                                                {highlightFolders.map(folder => (
                                                  <option key={folder.id} value={folder.id}>{folder.name}</option>
                                                ))}
                                              </Form.Control>
                                            </div>
                                            <div className="px-3 pb-3">
                                              <div className="myvideo-highlight-playlist-card">
                                                <div className="myvideo-highlight-playlist-card-title">{t('PLAYLIST')}</div>
                                                {getAvailableFlatCameras(v).length === 0 ? (
                                                  <div className="myvideo-highlight-playlist-card-muted">{t('MYVIDEO_NO_FLAT_CAMERAS')}</div>
                                                ) : (
                                                  <Fragment>
                                                    {getAvailableFlatCameras(v).length > 1 ? (
                                                      <Form.Control
                                                        as="select"
                                                        className="mb-2"
                                                        value={getSelectedHighlightCameraId(v) || ''}
                                                        onChange={changeHighlightPlaylistCamera(v.videoId)}
                                                      >
                                                        {getAvailableFlatCameras(v).map(camera => (
                                                          <option key={camera.value} value={camera.value}>{camera.label || camera.name || `Camera ${camera.value}`}</option>
                                                        ))}
                                                      </Form.Control>
                                                    ) : null}
                                                    <Button
                                                      className={`btn myvideo-action myvideo-action--playlist w-100 ${selectedHighlightIds.includes(v.videoId) ? 'active' : ''}`}
                                                      onClick={toggleHighlightSelection(v)}
                                                    >
                                                      <FaFolderPlus aria-hidden="true"/>{selectedHighlightIds.includes(v.videoId) ? t('MYVIDEO_SELECTED_FOR_PLAYLIST') : t('MYVIDEO_ADD_TO_PLAYLIST')}
                                                    </Button>
                                                  </Fragment>
                                                )}
                                              </div>
                                            </div>
                                            <div className="card_border_bottom_white text-center mt-auto mb-3">
                                              <button type="button" className="btn myvideo-action myvideo-action--share mb-3 ml-1 mr-1" onClick={showVideosSharing(v)}><FaShareAlt aria-hidden="true"/>{t('SHARE')}</button>
                                              <button type="button" className="btn myvideo-action myvideo-action--download mb-3 ml-1 mr-1" onClick={event => {event.stopPropagation(); confirmDownloadVideo(v)();}}><FaDownload aria-hidden="true"/>{t('DOWNLOAD')}</button>
                                            </div>
                                            <ul className="card_video_archive_list_icons mb-3">
                                              <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')}/></button></li>
                                              <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeleteVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')}/></button></li>
                                              {
                                                v.sharing === sharingType.none ?
                                                  <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={privateIcon} alt={t('ICON_USER_PRIVATE')}/><br/>{t('PRIVATE')}</li> :
                                                  null
                                              }
                                              {
                                                v.sharing === sharingType.public ?
                                                  <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={publicIcon} alt={t('ICON_USER_PUBLIC')}/><br/>{t('PUBLIC')}</li> :
                                                  null
                                              }
                                              {
                                                v.sharing === sharingType.replayer ?
                                                  <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={replayerIcon} alt={t('ICON_USER_REPLAYER')}/><br/>{t('REPLAYER_USERS')}</li> :
                                                  null
                                              }
                                              <p style={{textAlign: 'right', paddingRight: 10, paddingTop: 10, whiteSpace: 'nowrap'}}>{(Math.floor(v.filesize)/(1000000000)).toFixed(2)}GB</p>
                                              <li className="skywork-video-card-footer-folder"><FaFolder aria-hidden="true"/><span>{t('MYVIDEO_FOLDER')}: {v.highlightFolderName || t('MYVIDEO_WITHOUT_FOLDER')}</span></li>
                                            </ul>
                                          </Fragment>
                                        );
                                      }}
                                    </Formik>
                                  </div>
                                </div>
                              ))
                          }
                          <div className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="empty_slot card video_card_bg_rp">
                              <div className="card_image_rp">
                                <div className="videoWrapper"/>
                              </div>
                              <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{t('ADD_NEW_HIGHLIGHT_HERE')}</h5>
                                <p>
                                  {t('HIGH_DEFINITION_HIGHLIGHT_SHOOTING_FIELDS')}
                                </p>
                                <div className="text-center mt-auto">
                                  <button type="button" className="btn myvideo-action myvideo-action--utility mb-2" onClick={() => setActiveTab('video')}><FaFilm aria-hidden="true"/>{t('MY_VIDEO')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="video" title={<span className="section-tab-label"><FaFilm aria-hidden="true"/>{t('REPLAYER_VIDEOS')}</span>} tabClassName="myvideo-tab myvideo-tab--replayer">
                        <div className="myvideo-highlight-organizer" style={{marginTop: 35}}>
                          <div className="myvideo-highlight-organizer-header">
                            <div>
                              <h5>{t('ORGANIZE_VIDEOS')}</h5>
                              <p>{t('ORGANIZE_VIDEOS_DESCRIPTION')}</p>
                            </div>
                            <div className="myvideo-highlight-header-actions">
                              <Button className="myvideo-highlight-guide-btn" onClick={() => setVideoGuideModalVisible(true)}>{t('VIDEO_GUIDE')}</Button>
                              <div className="myvideo-highlight-total">{replayerVideos.length} video</div>
                            </div>
                          </div>
                          <div className="row align-items-stretch myvideo-highlight-controls">
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                                <Form.Label className="myvideo-folder-control-label"><FaFilter aria-hidden="true"/><span>{t('VIEW')}</span></Form.Label>
                                <Form.Control className="myvideo-folder-select" as="select" value={activeVideoFolderId} onChange={event => setActiveVideoFolderId(event.target.value)}>
                                  <option value="all">{t('MYVIDEO_ALL_VIDEOS', {count: replayerVideos.length})}</option>
                                  <option value="none">{t('MYVIDEO_VIDEOS_WITHOUT_FOLDER', {count: videosWithoutFolderCount})}</option>
                                  {videoFolders.map(folder => (
                                    <option key={folder.id} value={folder.id}>{t('MYVIDEO_FOLDER_OPTION', {name: folder.name, count: getVideoFolderCount(folder.id)})}</option>
                                  ))}
                                </Form.Control>
                                <small className="myvideo-folder-control-hint">{t('MYVIDEO_VIDEOS_IN_SELECTION', {count: visibleReplayerVideos.length})}</small>
                              </div>
                            </div>
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                                <Form onSubmit={addVideoFolder}>
                                  <Form.Label className="myvideo-folder-control-label"><FaFolderPlus aria-hidden="true"/><span>{t('NEW_FOLDER')}</span></Form.Label>
                                  <div className="input-group myvideo-folder-create-control">
                                    <Form.Control maxLength={120} value={newVideoFolderName} placeholder={t('FOLDER_NAME')} onChange={event => setNewVideoFolderName(event.target.value)}/>
                                    <div className="input-group-append">
                                      <Button type="submit" className="btn myvideo-action myvideo-folder-create-btn" disabled={!newVideoFolderName.trim()}><FaPlus aria-hidden="true"/>{t('CREATE')}</Button>
                                    </div>
                                  </div>
                                  <small className="myvideo-folder-control-hint">{t('VIDEO_FOLDER_HINT')}</small>
                                </Form>
                              </div>
                            </div>
                            <div className="col-md-2 mb-3 text-md-right">
                              {selectedVideoFolder ? (
                                <div className="myvideo-highlight-folder-actions">
                                  <Button className="myvideo-action myvideo-action--danger" onClick={deleteSelectedVideoFolder}><FaTrashAlt aria-hidden="true"/>{t('MYVIDEO_DELETE_FOLDER')}</Button>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{marginTop: 50}}>
                          {visibleReplayerVideos.length === 0 ? (
                            <div className="col-12">
                              <div className="myvideo-highlight-empty">
                                {selectedVideoFolder
                                  ? t('MYVIDEO_EMPTY_VIDEO_FOLDER')
                                  : t('MYVIDEO_NO_VIDEOS_SELECTION')}
                              </div>
                            </div>
                          ) : null}
                          {
                            visibleReplayerVideos.map(v =>
                              (
                                <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                  <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--replayer">
                                    <div className="video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                      <div className="videoWrapper" onMouseEnter={preconnectVideoPlayer} onTouchStart={preconnectVideoPlayer} onClick={() => {sendUsageData(usageTypes['replayer_video'], v.partnerId, v.slotId); openPlayerUrl(`${Configuration.krpanoPlayerUrl}?slotId=${v.slotId}&token=${v.token}`);}}>
                                        <Fragment>
                                          <div className="preload h-100 justify-content-center align-items-center">
                                            <img className="play_arrow" src={playArrowWhite} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-start align-items-start">
                                            <img className="logo-replayer" src={replayerlogoBianco} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-end align-items-start">
                                            <img className="logo-partner" src={getPartnerLogo(v.partnerId)} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-center align-items-end">
                                            <div className="video-description justify-content-center align-items-center">{v.name.substring(0,60)}</div>
                                          </div>
                                        </Fragment>
                                      </div>
                                    </div>
                                    <Formik
                                      enableReinitialize
                                      initialValues={{videoId: v.videoId, name: v.name, description: v.description, renaming: false}}
                                      onSubmit={values => modifyPlayerPermanentVideo(values.videoId, {name: values.name, description: values.description})}
                                    >
                                      {({
                                        handleSubmit,
                                        handleChange,
                                        values,
                                        setFieldValue
                                      }) => {
                                        const rename = formData => {
                                          handleSubmit(formData);
                                          setFieldValue('renaming', false);
                                        };

                                        const setRenameAndScroll = () => {
                                          setScrollPosition(getScrollPage());
                                          setFieldValue('renaming', true);
                                        };

                                        if (values.renaming) {
                                          return (
                                            <div className="card-body d-flex flex-column">
                                              <Form onSubmit={rename}>
                                                <Form.Group>
                                                  <Form.Label>{t('TITLE')}*</Form.Label>
                                                  <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={255} value={values.name || ''} onChange={handleChange}/>
                                                </Form.Group>
                                                <Form.Group>
                                                  <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                  <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange}/>
                                                </Form.Group>
                                                <div className="d-flex flex-row-reverse">
                                                  <button type="button" className="btn btn_red_outline_rp ml-1" onClick={() => setFieldValue('renaming', false)}>{t('CANCEL')}</button>
                                                  <Button className="btn btn-secondary ml-1 mr-1" type="submit">{t('SAVE')}</Button>
                                                </div>
                                              </Form>
                                            </div>
                                          );
                                        }

                                        return (
                                          <Fragment>
                                            <div className="card-body d-flex flex-column">
                                              <div className="skywork-video-card-title-box"><h5 className="card-title">{v.name}</h5></div>
                                              <div className="video_card_star_btn_active" onClick={metadataVideo(v)}/>
                                              <div className="skywork-video-card-description-box">{v.description || t('VIDEO_ANALYSIS_NO_DESCRIPTION')}</div>
                                            </div>
                                            <div className="px-3 pb-3 myvideo-card-folder-control">
                                              <Form.Label><FaFolder aria-hidden="true"/><span>{t('MYVIDEO_ARCHIVE_IN')}</span></Form.Label>
                                              <Form.Control className="myvideo-card-folder-select" as="select" value={v.videoFolderId || ''} onChange={event => movePlayerVideoToFolder(v.videoId, event.target.value ? Number(event.target.value) : null)}>
                                                <option value="">{t('MYVIDEO_WITHOUT_FOLDER')}</option>
                                                {videoFolders.map(folder => (
                                                  <option key={folder.id} value={folder.id}>{folder.name}</option>
                                                ))}
                                              </Form.Control>
                                            </div>
                                            <div className="card_border_bottom_white text-center mt-auto mb-3">
                                              {Array.isArray(v.cameras) && v.cameras.some(c => c.camera_type === 'flat') && (<button type="button" className="btn myvideo-action myvideo-action--tag mb-3 ml-1 mr-1" onClick={showVideoTagging(v)}><FaTag aria-hidden="true"/>{t('VIDEO_TAG_CREATE')}</button>)}
                                              <button type="button" className="btn myvideo-action myvideo-action--highlight mb-3 ml-1 mr-1" onClick={selectVideoForHighlight(v)}><FaMagic aria-hidden="true"/>{t('HIGHLIGHT')}</button>
                                              {isPickleballVideo(v) ? <button type="button" className="btn myvideo-action myvideo-action--analysis mb-3 ml-1 mr-1" onClick={selectVideoForAnalysis(v)}><FaChartBar aria-hidden="true"/>{t('VIDEO_ANALYSIS_TITLE')}</button> : null}
                                            </div>
                                            <ul className="card_video_archive_list_icons mb-3">
                                              <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')}/></button></li>
                                              <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeleteVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')}/></button></li>
                                              <p style={{textAlign: 'right', paddingRight: 10, paddingTop: 10}}>{(Math.floor(v.filesize)/(1000000000)).toFixed(2)}GB</p>
                                              <li className="skywork-video-card-footer-folder"><FaFolder aria-hidden="true"/><span>{t('MYVIDEO_FOLDER')}: {v.videoFolderName || t('MYVIDEO_WITHOUT_FOLDER')}</span></li>
                                            </ul>
                                          </Fragment>
                                        );
                                      }}
                                    </Formik>
                                  </div>
                                </div>
                              ))
                          }
                          <div className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="empty_slot card video_card_bg_rp">
                              <div className="card_image_rp">
                                <div className="videoWrapper"/>
                              </div>
                              <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{t('ADD_NEW_VIDEO_HERE')}</h5>
                                <p>
                                  {t('HIGH_DEFINITION_VIDEO_SHOOTING_FIELDS')}
                                </p>
                                <div className="text-center mt-auto">
                                  <button type="button" className="btn btn_red_rp mb-2" onClick={goto('player-show-sport-centers')}>{t('SPORT_CENTERS')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="partner_videos" title={<span className="section-tab-label"><FaHandshake aria-hidden="true"/>{t('PARTNER_VIDEOS')}</span>} tabClassName="myvideo-tab myvideo-tab--partner">
                        <div className="row" style={{marginTop: 50}}>
                          {
                            permanentPartnerVideos.map(v =>
                              (
                                <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                  <div className="card video_partner_card_bg_rp skywork-video-content-card skywork-video-content-card--partner">
                                    <div className="video_card_image" style={styleBackgroundImageVideoPartner(v.partnerId, v.coverImage, v.defaultImage, v.videoId)}>
                                      <div className="videoWrapper" onMouseEnter={preconnectVideoPlayer} onTouchStart={preconnectVideoPlayer} onClick={() => {sendUsageData(usageTypes['partner_video'], v.partnerId, null, v.title, v.videoName); openPlayerUrl(`${Configuration.krpanoPlayerUrl}?userVideoPartnerId=${v.videoId}&token=${v.token}`);}}>
                                        <Fragment>
                                          <div className="preload h-100 justify-content-center align-items-center">
                                            <img className="play_arrow" src={playArrowWhite} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-start align-items-start">
                                            <img className="logo-replayer" src={replayerlogoBianco} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-end align-items-start">
                                            <img className="logo-partner" src={getPartnerLogo(v.partnerId)} alt=""/>
                                          </div>
                                          <div className="preload h-100 justify-content-center align-items-end">
                                            <div className="video-description justify-content-center align-items-center">{v.title}</div>
                                          </div>
                                        </Fragment>
                                      </div>
                                    </div>
                                    <Fragment>
                                      <div className="card-body d-flex flex-column">
                                        <h5 className="card-title">{v.title}</h5>
                                        <ul className="list-unstyled">
                                          <li>{v.description}</li>
                                        </ul>
                                      </div>
                                      <div className="card_border_bottom_red mt-auto mb-3" style={{paddingLeft: 20, paddingRight: 20}}>

                                      </div>
                                      <ul className="card_video_archive_list_icons mb-3" style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <div>
                                        <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeletePartnerVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')}/></button></li>
                                        </div>
                                        <p style={{textAlign: 'right', paddingRight: 10, paddingTop: 10}}>{(Math.floor(v.filesize)/(1000000000)).toFixed(2)}GB</p>
                                      </ul>
                                    </Fragment>
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                      </Tab>
                      <Tab eventKey="analysis" title={<span className="section-tab-label"><FaChartBar aria-hidden="true"/>{t('VIDEO_ANALYSIS_TITLE')}</span>} tabClassName="myvideo-tab myvideo-tab--analysis">
                        <div className="myvideo-highlight-organizer" style={{marginTop: 35}}>
                          <div className="myvideo-highlight-organizer-header">
                            <div>
                              <h5>{t('VIDEO_ANALYSIS_TITLE')}</h5>
                              <p>{t('VIDEO_ANALYSIS_INTRO')}</p>
                            </div>
                            <div className="myvideo-highlight-header-actions">
                              <div className="myvideo-highlight-total">{t('VIDEO_ANALYSIS_COUNT', {count: analysisRequests.length})}</div>
                            </div>
                          </div>
                        </div>
                        {loadingAnalysisRequests && (
                          <div className="d-flex align-items-center" style={{marginTop: 35}}>
                            <Spinner animation="border" size="sm" className="mr-2"/>
                            {t('VIDEO_ANALYSIS_LOADING')}
                          </div>
                        )}
                        {analysisRequestsError && (
                          <Alert variant="danger" style={{marginTop: 35}}>
                            {analysisRequestsError}
                          </Alert>
                        )}
                        <div className="row" style={{marginTop: 50}}>
                          {!loadingAnalysisRequests && analysisRequests.length === 0 ? (
                            <div className="col-12">
                              <div className="myvideo-highlight-empty">
                                {t('VIDEO_ANALYSIS_EMPTY')}
                              </div>
                            </div>
                          ) : null}
                          {analysisRequests.map(request => {
                            const url = analysisResultUrl(request);
                            const status = request.status || request.providerStatus || request.provider_status;
                            const title = request.title || request.videoTitle || request.contentTitle || t('VIDEO_ANALYSIS_DEFAULT_TITLE');
                            const description = request.description || request.videoDescription || request.contentDescription;
                            const createdAt = request.createdAt || request.created_at;
                            const canDeleteAnalysis = !['queued_to_provider', 'processing'].includes(status);
                            return (
                              <div key={request.id} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                <div className="card video_card_bg_rp skywork-analysis-card">
                                  <div className="card-body d-flex flex-column">
                                    <div className="skywork-video-card-title-box"><h5 className="card-title">{title}</h5></div>
                                    <div className="skywork-video-card-description-box">{description || t('VIDEO_ANALYSIS_NO_DESCRIPTION')}</div>
                                    <div className={`skywork-analysis-status-box skywork-analysis-status-box--${status || 'unknown'}`}>
                                      <div className="skywork-analysis-status-heading"><FaChartBar aria-hidden="true"/><span>{analysisStatusLabel(status)}</span></div>
                                      <ul className="list-unstyled">
                                        <li>{analysisStatusDescription(status)}</li>
                                        <li><strong>{t('VIDEO_ANALYSIS_CLIP')}:</strong> {formatAnalysisRange(request)}</li>
                                        <li><strong>{t('VIDEO_ANALYSIS_COST')}:</strong> {formatAnalysisPrice(request)}</li>
                                        {request.errorReason ? <li><strong>{t('VIDEO_ANALYSIS_ERROR')}:</strong> {request.errorReason}</li> : null}
                                        {createdAt ? <li><strong>{t('VIDEO_ANALYSIS_REQUESTED')}:</strong> {new Date(createdAt).toLocaleString(i18n.language)}</li> : null}
                                      </ul>
                                    </div>
                                    <div className="text-center mt-auto">
                                      {status === 'available' && replayerAnalysisUiEnabled ? (
                                        <Button className="btn myvideo-action myvideo-action--analysis mb-2" onClick={goto(`/player-video-analysis/${request.id}`)}>
                                          <FaChartBar aria-hidden="true"/>{t('VIDEO_ANALYSIS_OPEN_REPLAYER')}
                                        </Button>
                                      ) : url ? (
                                        <a href={url} target="_blank" rel="noopener noreferrer" className="btn myvideo-action myvideo-action--analysis mb-2">
                                          <FaExternalLinkAlt aria-hidden="true"/>{t('VIDEO_ANALYSIS_OPEN')}
                                        </a>
                                      ) : (
                                                <Button className="btn myvideo-action myvideo-action--utility mb-2" disabled>
                                          {analysisStatusLabel(status)}
                                        </Button>
                                      )}
                                      {status === 'available' && replayerAnalysisUiEnabled && url ? (
                                        <a href={url} target="_blank" rel="noopener noreferrer" className="btn myvideo-action myvideo-action--external mb-2 ml-2">
                                          <FaExternalLinkAlt aria-hidden="true"/>{t('OPEN_PB_VISION')}
                                        </a>
                                      ) : null}
                                      {status === 'available' && replayerAnalysisUiEnabled ? (
                                        <Button
                                          className="btn myvideo-action myvideo-action--share mb-2 ml-2"
                                          onClick={openAnalysisSharing(request)}
                                        >
                                          <FaShareAlt aria-hidden="true"/>Condividi
                                        </Button>
                                      ) : null}
                                      {canDeleteAnalysis ? (
                                        <Button
                                          className="btn myvideo-action myvideo-action--danger mb-2 ml-2"
                                          onClick={deleteAnalysisRequest(request)}
                                          disabled={deletingAnalysisRequestId === request.id}
                                        >
                                          <FaTrashAlt aria-hidden="true"/>{deletingAnalysisRequestId === request.id ? 'Cancellazione...' : 'Cancella'}
                                        </Button>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Tab>
                      <Tab eventKey="tags" title={<span className="section-tab-label"><FaTag aria-hidden="true"/>{t('TAGS')}</span>} tabClassName="myvideo-tab myvideo-tab--tags">
                        {
                          selectedVideoForTagging ?
                            <PlayerVideoTagging setValue={setValue}/> :
                            <div className="container pt-5">
                              <div className="row mb-4">
                                <div className="col-12">
                                  <div>
                                    <div className="d-flex" style={{flexDirection: 'row', flexWrap: 'wrap'}}>
                                      <div><h4 className="section_title_neg_rp">{t('TAG_SELECT')}</h4></div>
                                      <div className="ml-auto d-xs-block"><Button className="btn myvideo-action myvideo-action--tag" onClick={showPlayerTags}><FaTag aria-hidden="true"/>{t('TAG_CREATE_OR_UPDATE')}</Button></div>
                                    </div>
                                    <hr className="hr_blue"/>
                                    <div className="row">
                                      <div className="col-lg-12 mt-sm-2">
                                        {userTags.length > 0 ?
                                          <p>{t('TAG_INFO')}</p>
                                          : <p>{t('NO_TAG_CREATED')}</p>
                                        }
                                        <h3>
                                          <ToggleButtonGroup type="checkbox" className="flex-wrap" onChange={handleTagSelection}>
                                            {userTags.map(t => <ToggleButton key={t.id} style={{fontFamily:"Arial", margin: 2, backgroundColor: t.color, borderColor: t.color, marginRight: 5, opacity: value && value.includes(t.id) ? 1 : 0.5}} value={t.id}>{t.label}</ToggleButton>)}
                                          </ToggleButtonGroup>
                                        </h3>
                                        {userTags.length > 0 && taggedUserVideos.length === 0 ?
                                          <p>{t('NO_VIDEO_TAGGED')}</p>
                                        : null}
                                      </div>
                                    </div>
                                    <div className="row" style={{marginTop: 50}}>
                                      {
                                        taggedUserVideos.map(v =>
                                          (
                                            <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                              <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--tagged">
                                                <div className="video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                                  <div className="videoWrapper" onClick={showVideoTagging(v)}>
                                                    <Fragment>
                                                      <div className="preload h-100 justify-content-start align-items-start">
                                                        <img className="logo-replayer" src={replayerlogoBianco} alt=""/>
                                                      </div>
                                                      <div className="preload h-100 justify-content-end align-items-start">
                                                        <img className="logo-partner" src={getPartnerLogo(v.partnerId)} alt=""/>
                                                      </div>
                                                      <div className="preload h-100 justify-content-center align-items-end">
                                                        <div className="video-description justify-content-center align-items-center">{v.name.substring(0,60)}</div>
                                                      </div>
                                                    </Fragment>
                                                  </div>
                                                </div>
                                                <Formik
                                                  enableReinitialize
                                                  initialValues={{videoId: v.videoId, name: v.name, description: v.description, renaming: false}}
                                                  onSubmit={values => modifyPlayerPermanentVideo(values.videoId, {name: values.name, description: values.description})}
                                                >
                                                  {({
                                                    handleSubmit,
                                                    handleChange,
                                                    values,
                                                    setFieldValue
                                                  }) => {
                                                    const rename = formData => {
                                                      handleSubmit(formData);
                                                      setFieldValue('renaming', false);
                                                    };

                                                    const setRenameAndScroll = () => {
                                                      setScrollPosition(getScrollPage());
                                                      setFieldValue('renaming', true);
                                                    };            

                                                    if (values.renaming) {
                                                      return (
                                                        <div className="card-body d-flex flex-column">
                                                          <Form onSubmit={rename}>
                                                            <Form.Group>
                                                              <Form.Label>{t('TITLE')}*</Form.Label>
                                                              <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={255} value={values.name || ''} onChange={handleChange}/>
                                                            </Form.Group>
                                                            <Form.Group>
                                                              <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                              <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange}/>
                                                            </Form.Group>
                                                            <div className="d-flex flex-row-reverse">
                                                              <button type="button" className="btn btn_red_outline_rp ml-1" onClick={() => setFieldValue('renaming', false)}>{t('CANCEL')}</button>
                                                              <Button className="btn btn-secondary ml-1 mr-1" type="submit">{t('SAVE')}</Button>
                                                            </div>
                                                          </Form>
                                                        </div>
                                                      );
                                                    }

                                                    return (
                                                      <Fragment>
                                                        <div className="card-body d-flex flex-column">
                                                          <h5 className="card-title">{v.name}</h5>
                                                          <div className="video_card_star_btn_active" onClick={metadataVideo(v)}/>
                                                          <ul className="list-unstyled">
                                                            <li>{v.description}</li>
                                                          </ul>
                                                        </div>
                                                        <div className="card_border_bottom_white text-center mt-auto mb-3">
                                                          <button type="button" className="btn myvideo-action myvideo-action--tag mb-3 ml-1 mr-1" onClick={showVideoTagging(v)}><FaTag aria-hidden="true"/>{t('VIDEO_TAG_CREATE')}</button>
                                                          <button type="button" className="btn myvideo-action myvideo-action--highlight mb-3 ml-1 mr-1" onClick={selectVideoForHighlight(v)}><FaMagic aria-hidden="true"/>{t('HIGHLIGHT')}</button>
                                                        </div>
                                                        <ul className="card_video_archive_list_icons mb-3">
                                                          <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')}/></button></li>
                                                          <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeleteVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')}/></button></li>
                                                          <p style={{textAlign: 'right', paddingRight: 10, paddingTop: 10}}>{(Math.floor(v.filesize)/(1000000000)).toFixed(2)}GB</p>
                                                        </ul>
                                                      </Fragment>
                                                    );
                                                  }}
                                                </Formik>
                                              </div>
                                            </div>
                                          ))
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        }
                        <PlayerTags/>
                      </Tab>
                      <Tab eventKey="playlist" title={<span className="section-tab-label"><FaFolderPlus aria-hidden="true"/>{t('PLAYLIST')}</span>} tabClassName="myvideo-tab myvideo-tab--playlist">
                        <div className="row" style={{marginTop: 50}}>
                        {
                          playlists.map(v =>
                            (
                              <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--playlist">
                                  <div className="video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                    <div className="videoWrapper" onMouseEnter={preconnectVideoPlayer} onTouchStart={preconnectVideoPlayer} onClick={() => {sendUsageData(usageTypes['playlist'], v.partnerId, v.slotId); openPlayerUrl(`${Configuration.krpanoPlayerUrl}?slotId=${v.slotId}&playlistId=${v.id}&token=${v.token}`);}}>
                                      <Fragment>
                                        <div className="preload h-100 justify-content-center align-items-center">
                                          <img className="play_arrow" src={playArrowWhite} alt=""/>
                                        </div>
                                        <div className="preload h-100 justify-content-start align-items-start">
                                          <img className="logo-replayer" src={replayerlogoBianco} alt=""/>
                                        </div>
                                        <div className="preload h-100 justify-content-end align-items-start">
                                          <img className="logo-partner" src={getPartnerLogo(v.partnerId)} alt=""/>
                                        </div>
                                        <div className="preload h-100 justify-content-center align-items-end">
                                          <div className="video-description justify-content-center align-items-center">{v.name.substring(0,60)}</div>
                                        </div>
                                      </Fragment>
                                    </div>
                                  </div>
                                  <Formik
                                    enableReinitialize
                                    initialValues={{id: v.id, name: v.name, description: v.description, renaming: false}}
                                    onSubmit={values => modifyPlaylist(values.id, {name: values.name, description: values.description})}
                                  >
                                    {({
                                      handleSubmit,
                                      handleChange,
                                      values,
                                      setFieldValue
                                    }) => {
                                      const rename = formData => {
                                        handleSubmit(formData);
                                        setFieldValue('renaming', false);
                                      };

                                      const setRenameAndScroll = () => {
                                        setScrollPosition(getScrollPage());
                                        setFieldValue('renaming', true);
                                      };

                                      if (values.renaming) {
                                        return (
                                          <div className="card-body d-flex flex-column">
                                            <Form onSubmit={rename}>
                                              <Form.Group>
                                                <Form.Label>{t('TITLE')}*</Form.Label>
                                                <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={50} value={values.name || ''} onChange={handleChange}/>
                                              </Form.Group>
                                              <Form.Group>
                                                <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange}/>
                                              </Form.Group>
                                              <div className="d-flex flex-row-reverse">
                                                <button type="button" className="btn myvideo-action myvideo-action--utility ml-1" onClick={() => setFieldValue('renaming', false)}><FaTimes aria-hidden="true"/>{t('CANCEL')}</button>
                                                <Button className="btn myvideo-action myvideo-action--primary ml-1 mr-1" type="submit"><FaSave aria-hidden="true"/>{t('SAVE')}</Button>
                                              </div>
                                            </Form>
                                          </div>
                                        );
                                      }

                                      return (
                                        <Fragment>
                                          <div className="card-body d-flex flex-column">
                                            <div className="skywork-video-card-title-box"><h5 className="card-title">{v.name}</h5></div>
                                            <div className="video_card_star_btn_active" onClick={metadataVideo(v)}/>
                                            <div className="skywork-video-card-description-box">{v.description || t('VIDEO_ANALYSIS_NO_DESCRIPTION')}</div>
                                          </div>
                                          <div className="card_border_bottom_white text-center mt-auto mb-3">
                                            <button type="button" className="btn myvideo-action myvideo-action--share mb-3 ml-1 mr-1" onClick={showVideosSharing(v)}><FaShareAlt aria-hidden="true"/>{t('SHARE')}</button>
                                            {playlistExportAction(v)}
                                            {v.exportStatus === 'error' ? (
                                              <div className="playlist-export-status playlist-export-status-error">{t('PLAYLIST_GENERATION_FAILED')}</div>
                                            ) : null}
                                            {v.exportStatus === 'pending' || v.exportStatus === 'running' ? (
                                              <div className="playlist-export-status">{t('PLAYLIST_GENERATING')}</div>
                                            ) : null}
                                          </div>
                                          <ul className="card_video_archive_list_icons mb-3">
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')}/></button></li>
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeletePlaylist(v.id)}><img src={binIcon} alt={t('ICON_DELETE')}/></button></li>
                                            {
                                              v.sharing === sharingType.none ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={privateIcon} alt={t('ICON_USER_PRIVATE')}/><br/>{t('PRIVATE')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.public ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={publicIcon} alt={t('ICON_USER_PUBLIC')}/><br/>{t('PUBLIC')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.replayer ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={replayerIcon} alt={t('ICON_USER_REPLAYER')}/><br/>{t('REPLAYER_USERS')}</li> :
                                                null
                                            }
                                            <p style={{textAlign: 'right', paddingRight: 10, paddingTop: 10, whiteSpace: 'nowrap'}}>{(Math.floor(v.exportFilesize || v.filesize || 0)/(1000000000)).toFixed(2)}GB</p>
                                          </ul>
                                        </Fragment>
                                      );
                                    }}
                                  </Formik>
                                </div>
                              </div>
                            ))
                        }
                        <div className="col-md-12 col-lg-4 mb-sm-4 card-group">
                          <div className="empty_slot card video_card_bg_rp">
                            <div className="card_image_pl">
                              <div className="videoWrapper"/>
                            </div>
                            <div className="card-body d-flex flex-column">
                              <h5 className="card-title">{t('ADD_NEW_PLAYLIST_HERE')}</h5>
                              <p>
                                {t('PLAYLIST_INFO')}
                              </p>
                              <div className="text-center mt-auto">
                                <button type="button" className="btn myvideo-action myvideo-action--utility mb-2" onClick={() => setActiveTab('video')}><FaFilm aria-hidden="true"/>{t('MY_VIDEO')}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
      {
        selectedPermanentVideo === null ?
          null :
          <PlayerHighLight video={selectedPermanentVideo}/>
      }
      {
        selectedPermanentVideo === null ?
          null :
          <PlayerVideoSharing video={selectedPermanentVideo}/>
      }
      <Modal
        className="myvideo-action-confirm-modal"
        centered
        show={videoActionModal !== null}
        onHide={() => setVideoActionModal(null)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {videoActionModal && videoActionModal.type === 'delete' ? <FaTrashAlt aria-hidden="true"/> : <FaDownload aria-hidden="true"/>}
            <span>{videoActionModal && videoActionModal.type === 'delete' ? t('CONFIRM_DELETE_VIDEO') : t('CONFIRM_DOWNLOAD_VIDEO')}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {videoActionModal && videoActionModal.type === 'delete' ? (
            <div className="myvideo-action-confirm-message">
              <div className="myvideo-action-confirm-icon myvideo-action-confirm-icon--danger"><FaTrashAlt aria-hidden="true"/></div>
              <p>{t('CONFIRM_DELETE_VIDEO_DESC')}</p>
            </div>
          ) : null}
          {videoActionModal && videoActionModal.type === 'download' ? (
            <Fragment>
              <div className="myvideo-action-confirm-message">
                <div className="myvideo-action-confirm-icon myvideo-action-confirm-icon--download"><FaDownload aria-hidden="true"/></div>
                <p>{t('CONFIRM_DOWNLOAD_VIDEO_DESC', {name: videoActionModal.video.name})}</p>
              </div>
              <div className="myvideo-download-choice-list">
                {videoActionModal.video.urls.map((url, index) => (
                  <a
                    key={`${url.url}-${url.cameraName || index}`}
                    href={url.url}
                    download={`${videoActionModal.video.name.split('.').join('')}_${url.cameraName}`}
                    className="btn myvideo-modal-download-btn"
                  >
                    <FaDownload aria-hidden="true"/>
                    <span>{t('DOWNLOAD')}{videoActionModal.video.urls.length > 1 ? ` ${url.cameraName}` : ''}</span>
                  </a>
                ))}
              </div>
            </Fragment>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button className="myvideo-modal-cancel-btn" onClick={() => setVideoActionModal(null)}><FaTimes aria-hidden="true"/>{t('CANCEL')}</Button>
          {videoActionModal && videoActionModal.type === 'delete' ? (
            <Button
              className="myvideo-modal-delete-btn"
              onClick={() => {
                deletePlayerPermanentVideo(videoActionModal.videoId);
                setVideoActionModal(null);
              }}
            >
              <FaTrashAlt aria-hidden="true"/>{t('YES_DELETE')}
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>
      <Dialog
        ref={el => {
          dialog = el;
        }}/>
      <Modal show={isHighlightPlaylistModalVisible} onHide={() => setHighlightPlaylistModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('MYVIDEO_CREATE_PLAYLIST_FROM_HIGHLIGHTS')}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{name: '', description: ''}}
          onSubmit={values => {
            createHighlightPlaylist({
              name: values.name,
              description: values.description,
              highlightItems: selectedHighlights.map(v => ({
                videoId: v.videoId,
                cameraId: getSelectedHighlightCameraId(v)
              }))
            });
            setHighlightPlaylistModalVisible(false);
            clearHighlightPlaylistSelection();
            setActiveTab('playlist');
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <p>{t('MYVIDEO_CREATE_PLAYLIST_HELP')}</p>
                <Form.Group>
                  <Form.Label>{t('MYVIDEO_PLAYLIST_NAME')}*</Form.Label>
                  <Form.Control required name="name" type="text" maxLength={50} placeholder={t('MYVIDEO_PLAYLIST_NAME_PLACEHOLDER')} value={values.name} onChange={handleChange}/>
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t('DESCRIPTION')}</Form.Label>
                  <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('MYVIDEO_OPTIONAL_DESCRIPTION')} value={values.description} onChange={handleChange}/>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn myvideo-action myvideo-action--utility" onClick={() => setHighlightPlaylistModalVisible(false)}><FaTimes aria-hidden="true"/>{t('CANCEL')}</Button>
                <Button className="btn myvideo-action myvideo-action--playlist" type="submit"><FaFolderPlus aria-hidden="true"/>{t('MYVIDEO_CREATE_PLAYLIST')}</Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal className="myvideo-highlight-guide-modal" show={isHighlightGuideModalVisible} onHide={() => setHighlightGuideModalVisible(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{t('MYVIDEO_HIGHLIGHT_GUIDE_TITLE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="myvideo-highlight-guide-intro">{t('MYVIDEO_HIGHLIGHT_GUIDE_INTRO')}</p>
          <div className="myvideo-highlight-guide-grid">
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT')}</h6>
              <p>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_FOLDER')}</h6>
              <p>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT_FOLDER_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_SHARE_HIGHLIGHTS')}</h6>
              <p>{t('MYVIDEO_GUIDE_SHARE_HIGHLIGHT_HELP')}</p>
              <p>{t('MYVIDEO_GUIDE_SHARE_FOLDER_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_PLAYLIST')}</h6>
              <p>{t('MYVIDEO_GUIDE_CREATE_PLAYLIST_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_FIND_PLAYLIST')}</h6>
              <p>{t('MYVIDEO_GUIDE_FIND_PLAYLIST_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_DOWNLOAD_PLAYLIST')}</h6>
              <p>{t('MYVIDEO_GUIDE_DOWNLOAD_PLAYLIST_HELP')}</p>
            </div>
          </div>
          <div className="myvideo-highlight-guide-extra"><strong>{t('MYVIDEO_GUIDE_REMEMBER')}</strong><span>{t('MYVIDEO_GUIDE_FLAT_CAMERA_NOTE')}</span></div>
          <div className="myvideo-highlight-guide-note">{t('MYVIDEO_GUIDE_HIGHLIGHTS_PRESERVED')}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn_red_rp" onClick={() => setHighlightGuideModalVisible(false)}>{t('UNDERSTOOD')}</Button>
        </Modal.Footer>
      </Modal>
      <Modal className="myvideo-highlight-guide-modal" show={isVideoGuideModalVisible} onHide={() => setVideoGuideModalVisible(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{t('MYVIDEO_VIDEO_GUIDE_TITLE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="myvideo-highlight-guide-intro">{t('MYVIDEO_VIDEO_GUIDE_INTRO')}</p>
          <div className="myvideo-highlight-guide-grid">
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_CREATE_HIGHLIGHT_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_VIDEO_GUIDE_CREATE_TAG')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_CREATE_TAG_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_VIDEO_GUIDE_CREATE_FOLDER')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_CREATE_FOLDER_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_VIDEO_GUIDE_MOVE_VIDEO')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_MOVE_VIDEO_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_DELETE_FOLDER')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_DELETE_FOLDER_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_VIDEO_GUIDE_FIND_CONTENT')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_FIND_CONTENT_HELP')}</p>
            </div>
          </div>
          <div className="myvideo-highlight-guide-extra"><strong>{t('MYVIDEO_VIDEO_GUIDE_TAG_OR_HIGHLIGHT')}</strong><span>{t('MYVIDEO_VIDEO_GUIDE_TAG_OR_HIGHLIGHT_HELP')}</span></div>
          <div className="myvideo-highlight-guide-note">{t('MYVIDEO_VIDEO_GUIDE_FOLDER_NOTE')}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn_red_rp" onClick={() => setVideoGuideModalVisible(false)}>{t('UNDERSTOOD')}</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={isStorageModalVisible} onHide={hideStorageModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t('MY_VIDEO_MANAGE_SPACE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Fragment>
            {profile.storageType === "xs" && profile.storageLegacyFree ? <p>{t('MY_VIDEO_LEGACY_FREE_NOTICE')}</p> : null}
            {t('MY_VIDEO_CHOOSE_SPACE')}
            <Formik
              initialValues={{storageType: selectableStorageType}}
              onSubmit={changeStorageType}
            >
              {({
                handleSubmit,
                setFieldValue,
                values
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_S',{price: storagePrices.s})} checked={values.storageType === "s"} onChange={() => setFieldValue('storageType', "s")}/>
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_M',{price: storagePrices.m})} checked={values.storageType === "m"} onChange={() => setFieldValue('storageType', "m")}/>
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_L',{price: storagePrices.l})} checked={values.storageType === "l"} onChange={() => setFieldValue('storageType', "l")}/>
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_XL',{price: storagePrices.xl})} checked={values.storageType === "xl"} onChange={() => setFieldValue('storageType', "xl")}/>
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_XXL',{price: storagePrices.xxl})} checked={values.storageType === "xxl"} onChange={() => setFieldValue('storageType', "xxl")}/>
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_XXXL',{price: storagePrices.xxxl})} checked={values.storageType === "xxxl"} onChange={() => setFieldValue('storageType', "xxxl")}/>
                    </Form.Group>
                    <Button type="submit" className="myvideo-action myvideo-action--primary" style={{marginBottom: 50}}><FaSave aria-hidden="true"/>{t('SAVE')}</Button>
                  </Form>
                );
              }}
            </Formik>
          </Fragment>
        </Modal.Body>
        <Modal.Footer>
          <Button className="myvideo-action myvideo-action--utility" onClick={hideStorageModal}>
            <FaTimes aria-hidden="true"/>{t('CLOSE_BUTTON')}
          </Button>
        </Modal.Footer>
      </Modal>
      <PlayerVideoAnalysisReport
        show={selectedAnalysisReportRequest !== null}
        request={selectedAnalysisReportRequest}
        token={token}
        providerUrl={selectedAnalysisReportRequest ? analysisResultUrl(selectedAnalysisReportRequest) : null}
        onHide={() => setSelectedAnalysisReportRequest(null)}
      />
      <PlayerVideoAnalysisSharing
        show={selectedAnalysisSharingRequest !== null}
        request={selectedAnalysisSharingRequest}
        token={token}
        onHide={() => setSelectedAnalysisSharingRequest(null)}
        onShared={updateSharedAnalysisRequest}
      />
    </Fragment>
  );
};

PlayerVideo.propTypes = {
  token: PropTypes.string,
  prifile: PropTypes.object,
  permanentVideos: PropTypes.array,
  permanentPartnerVideos: PropTypes.array,
  storagePrices: PropTypes.object,
  selectVideoForHighlight: PropTypes.func.isRequired,
  selectVideoForAnalysis: PropTypes.func.isRequired,
  selectedPermanentVideo: PropTypes.object,
  deletePlayerPermanentVideo: PropTypes.func.isRequired,
  deletePlaylist: PropTypes.func.isRequired,
  modifyPlaylist: PropTypes.func.isRequired,
  modifyPlayerPermanentVideo: PropTypes.func.isRequired,
  showVideosSharing: PropTypes.func.isRequired,
  partners: PropTypes.array.isRequired,
  addPermanentVideoPlaying: PropTypes.func.isRequired,
  permanentVideosPlaying: PropTypes.array.isRequired,
  showPlayerTags: PropTypes.func.isRequired,
  userTags: PropTypes.array,
  myVideoActiveTab: PropTypes.string,
  setActiveTab: PropTypes.func.isRequired,
  showVideoTagging: PropTypes.func.isRequired,
  selectedVideoForTagging: PropTypes.object,
  searchTaggedVideo: PropTypes.func.isRequired,
  taggedUserVideos: PropTypes.array,
  addTaggedVideoPlaying: PropTypes.func.isRequired,
  taggedVideosPlaying: PropTypes.array,
  changeStorageType: PropTypes.func.isRequired,
  isStorageModalVisible: PropTypes.bool.isRequired,
  showStorageModal: PropTypes.func.isRequired,
  hideStorageModal: PropTypes.func.isRequired,
  playlists: PropTypes.array.isRequired,
  highlightFolders: PropTypes.array.isRequired,
  videoFolders: PropTypes.array.isRequired,
  getPlayerPermanentVideos: PropTypes.func.isRequired,
  getPlayerPermanentPartnerVideos: PropTypes.func.isRequired,
  getPlayerPlaylists: PropTypes.func.isRequired,
  getUserTags: PropTypes.func.isRequired,
  getTaggedUserVideos: PropTypes.func.isRequired,
  playerGetStoragePrices: PropTypes.func.isRequired,
  getPlayerHighlightFolders: PropTypes.func.isRequired,
  createPlayerHighlightFolder: PropTypes.func.isRequired,
  deletePlayerHighlightFolder: PropTypes.func.isRequired,
  movePlayerHighlightToFolder: PropTypes.func.isRequired,
  getPlayerVideoFolders: PropTypes.func.isRequired,
  createPlayerVideoFolder: PropTypes.func.isRequired,
  deletePlayerVideoFolder: PropTypes.func.isRequired,
  movePlayerVideoToFolder: PropTypes.func.isRequired,
  createHighlightPlaylist: PropTypes.func.isRequired,
  exportPlaylist: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

PlayerVideo.defaultProps = {
  token: null,
  profile: null,
  permanentVideos: [],
  permanentPartnerVideos: [],
  storagePrices: {},
  selectedPermanentVideo: null,
  userTags: [],
  myVideoActiveTab: "video",
  selectedVideoForTagging: null,
  taggedUserVideos: [],
  taggedVideosPlaying: [],
  isStorageModalVisible: false,
  playlists: [],
  highlightFolders: [],
  videoFolders: []
};

export default PlayerVideo;
